<template>
  <div>
    <div class="container">
      <v-container>
        <v-row>
          <v-col class="text-center" style="margin-bottom: 40px">
            <h1 style="color: #05386c">ENQUIRY FORM</h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xl="8" lg="8" md="12" sm="12">
            <v-form v-model="formEnquiry" ref="formEnquiry">
              <v-row class="text-center">
                <v-col cols="6">
                  <v-text-field
                    v-model="info.Name"
                    label="First Name *"
                    :rules="[rules.required, rules.counter]"
                     maxlength="10"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="info.Lastname"
                    label="Last Name *"
                    :rules="[rules.required]"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row class="text-center">
                <v-col cols="6">
                  <v-text-field
                    v-model="info.Jobtitle"
                    label="Job title *"
                    :rules="[rules.required]"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="info.Company"
                    label="Company Name *"
                    :rules="[rules.required]"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row class="text-center">
                <v-col cols="6">
                  <v-text-field
                    v-model="info.Tel"
                    label="Telephone *"
                    :rules="[rules.required]"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field
                    v-model="info['E-mail']"
                    label="E-mail *"
                    :rules="[rules.required, rules.email]"
                    dense
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- Checkbox -->
              <v-row>
                <v-col>
                  <v-row style="height: 30px">
                    <v-col>
                      <h4>Infrastructure Services</h4>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" xl="6" lg="6" md="6">
                      <v-checkbox
                        v-model="checkbox['Data Center']"
                        label="Data Center"
                      ></v-checkbox>
                      <v-checkbox
                        v-model="checkbox.Connectivity"
                        label="Connectivity"
                      ></v-checkbox>
                    </v-col>

                    <v-col cols="12" xl="6" lg="6" md="6">
                      <v-checkbox
                        v-model="checkbox['Business Continuity Center']"
                        label="Business Continuity Center"
                      ></v-checkbox>
                      <v-checkbox
                        v-model="checkbox.Cloud"
                        label="Cloud"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-row style="height: 30px">
                    <v-col>
                      <h4>Managed Services</h4>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" xl="6" lg="6" md="6">
                      <v-checkbox
                        v-model="
                          checkbox['Infrastructure Managed Service (IMS)']
                        "
                        label="Infasturcture Managed Service (IMS)"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" xl="6" lg="6" md="6">
                      <v-checkbox
                        v-model="checkbox['Application Managed Service (AMS)']"
                        label="Application Managed Service (AMS)"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-row style="height: 30px">
                    <v-col>
                      <h4>Consulting Services</h4>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" xl="6" lg="6" md="6">
                      <v-checkbox
                        v-model="checkbox['Professional Services']"
                        label="Professional Services"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" xl="6" lg="6" md="6">
                      <v-checkbox
                        v-model="checkbox['IT Outsoucing']"
                        label="IT Outsoucing"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-row style="height: 30px">
                    <v-col>
                      <h4>Business Solutions Services</h4>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" xl="6" lg="6" md="6">
                      <v-checkbox
                        v-model="checkbox['Security Solutions']"
                        label="Security Solutions (Consulting/ Operation)"
                      ></v-checkbox>
                      </v-col>
                      <v-col cols="12" xl="6" lg="6" md="6">
                      <v-checkbox
                        v-model="checkbox['Data Platform']"
                        label="Data Platform (Data Engineering/ Data Operation)"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" xl="6" lg="6" md="6">
                      <v-checkbox
                        v-model="checkbox['ERP Solutions']"
                        label="ERP Solutions (Implementation/ Managed Services)"
                      ></v-checkbox>
                      </v-col>
                      <v-col cols="12" xl="6" lg="6" md="6">
                      <v-checkbox
                        v-model="
                          checkbox['Application Development']
                        "
                        label="Application Development (Web/Mobile Application)"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" xl="6" lg="6" md="6">
                      <v-checkbox
                        v-model="checkbox['Smart Solutions']"
                        label="Smart Solutions (Smart Energy/Facility/Factory Management and etc.)"
                      ></v-checkbox>
                      </v-col>
                      <v-col cols="12" xl="6" lg="6" md="6">
                      <v-checkbox
                        v-model="
                          checkbox['Others']
                        "
                        label="Others (EdTech and Digital Signature Processing Solutions)"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-textarea
                    v-model="info.Questions"
                    label="Questions Comments"
                    rows="3"
                    outlined
                    dense
                    row-height="20"
                  ></v-textarea>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-checkbox
                    v-model="checkbox.Privacy"
                    :rules="[rules.required]"
                  >
                    <template v-slot:label>
                      <div>
                        <div>
                          Privacy Policy <span style="color: red">*</span>
                        </div>
                        <div style="font-size: 14px">
                          I have read and agreed to the

                          <a
                            target="_blank"
                            href="https://www.tcc-technology.com/en/page/57/privacy"
                            @click.stop
                            style="color: #000; font-weight: 700"
                          >
                            Terms and Conditions
                          </a>
                          and acknowledged the

                          <a
                            target="_blank"
                            href="https://www.tcc-technology.com/en/page/76"
                            @click.stop
                            style="color: #000; font-weight: 700"
                          >
                            Privacy Policy
                          </a>
                        </div>
                      </div>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>

              <!-- Recaptcha -->
              <v-row>
                <v-col>
                  <vue-recaptcha
                    @verify="onVerify"
                    @expired="onExpired"
                    :sitekey="sitekey"
                    :loadRecaptchaScript="true"
                  >
                  </vue-recaptcha>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-btn
                    :disabled="!formEnquiry || !recaptcha"
                    large
                    block
                    tile
                    color="#05386c"
                    class="white--text"
                    @click="submit"
                    >Send Your Messages</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </v-col>

          <!-- Contact -->
          <v-col class="pl-10">
            <v-row>
              <v-col>
                <h3>Contact TCC Technology</h3>
              </v-col>
            </v-row>
            <v-row style="padding: 22px 0">
              <v-col cols="2" xl="1" lg="2">
                <v-avatar tile color="#05386c" size="30">
                  <v-icon dark small>mdi-email</v-icon>
                </v-avatar>
              </v-col>
              <v-col>
                <v-row>
                  <v-col>
                    <div style="color: #5c5e64">
                      <p>
                        <span>Office Team</span>
                        <br />
                        <small>Tel. 662 838 8888</small>
                        <br />
                        <small>sales@tcc-technology.com</small>
                        <br />
                        <small>marketing@tcc-technology.com</small>
                      </p>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <div style="color: #5c5e64">
                      <p>
                        <span>Helpdesk Team</span>
                        <br />
                        <small>Tel. 662 080 9888</small>
                        <br />
                        <small>helpdesk@tcc-technology.com</small>
                      </p>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <h3>Business Hours</h3>
              </v-col>
            </v-row>
            <v-row style="padding: 22px 0">
              <v-col cols="2" xl="1" lg="2" md="2" sm="2">
                <v-avatar tile color="#05386c" size="30">
                  <v-icon dark small>mdi-clock-time-nine</v-icon>
                </v-avatar>
              </v-col>
              <v-col>
                <v-row>
                  <v-col>
                    <div style="color: #5c5e64">
                      <p>
                        <span>Office Working Hours</span>
                        <br />
                        <small>Monday - Friday : 08.30 - 17.30</small>
                      </p>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <div style="color: #5c5e64">
                      <p>
                        <span>Helpdesk Operation Hours</span>
                        <br />
                        <small>Monday - Sunday : 24 Hours</small>
                      </p>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <!-- Snackbar -->
    <v-snackbar
      top
      v-model="snackbar"
      :timeout="timeout"
      :color="colorSnackbar"
    >
      {{ textSnackbar }}
      <template v-slot:action="{ attrs }">
        <v-icon dark v-bind="attrs">{{ iconSnackbar }}</v-icon>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
const { domain } = require("../constants/index");
import { mapActions } from "vuex";
import VueRecaptcha from "vue-recaptcha";
import axios from "axios";
export default {
  components: {
    VueRecaptcha,
  },
  data() {
    return {
      sitekey: "6LfbaEYaAAAAABuOBxnvBr3x07HcQpqVKojhnpMh",
      recaptcha: false,
      info: {
        web: "TCC-Technology",
        Name: "",
        Lastname: "",
        Jobtitle: "",
        Company: "",
        Tel: "",
        "E-mail": "",
        Questions: "",
      },
      checkbox: {
        "Data Center": false,
        "Business Continuity Center": false,
        Connectivity: false,
        Cloud: false,
        "Infrastructure Managed Service (IMS)": false,
        "Application Managed Service (AMS)": false,
        "Professional Services": false,
        "IT Outsoucing": false,
        "Security Solutions": false,
        "ERP Solutions": false,
        "Data Platform": false,
        "Application Development": false, 
        "Smart Solutions":false,
        "Others":false,
        Privacy: false,
      },
      formEnquiry: false,
      rules: {
        required: (value) => !!value || "Required.",
        counter: value => value.length <= 10 || 'Max 10 character',
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (!pattern.test(value)) {
            return "Invalid e-mail.";
          }
          return true;
        },
      },

      defaultInfo: {
        web: "TCC-Technology",
        Name: "",
        Lastname: "",
        Jobtitle: "",
        Company: "",
        Tel: "",
        "E-mail": "",
        Questions: "",
      },
      defaultCheckbox: {
        "Data Center": false,
        "Business Continuity Center": false,
        Connectivity: false,
        Cloud: false,
        "Infrastructure Managed Service (IMS)": false,
        "Application Managed Service (AMS)": false,
        "Professional Services": false,
        "IT Outsoucing": false,
        "Security Solutions": false,
        "ERP Solutions": false,
        "Data Platform": false,
        "Application Development": false,
        "Smart Solutions":false,
        "Others":false,
        Privacy: false,
      },

      /** snackbar */
      snackbar: false,
      snackbarError: false,
      timeout: 4000,
      textSnackbar: "",
      colorSnackbar: "",
      iconSnackbar: "",
    };
  },

  methods: {
    ...mapActions(["saveForm"]),
    onVerify(token) {
      axios
        .post(`${domain}/api/recaptcha/tcc-technology`, { token: token })
        .then((res) => {
          this.recaptcha = res.data.recaptcha;
        });
    },

    onExpired() {
      this.recaptcha = false;
    },

    submit() {
      const enquriyForm = {
        info: this.info,
        checkbox: this.checkbox,
      };
      this.saveForm(enquriyForm).then((res) => {
        if (res.data.success) {
          this.info = Object.assign({}, this.defaultInfo);
          this.checkbox = Object.assign({}, this.defaultCheckbox);
          this.$refs.formEnquiry.resetValidation();
          this.showSnackbarSuccess("Your message has been sent. Thank you.");
          setTimeout(() => {
            window.location.replace("https://www.tcc-technology.com/");
          }, 1000 * 2);
        } else {
          this.showSnackbarError("Error! Save from failed.");
        }
      });
    },

    // <----------------- Snackbar ----------------->

    showSnackbarSuccess(text) {
      this.snackbar = true;
      this.textSnackbar = text;
      this.colorSnackbar = "success";
      this.iconSnackbar = "mdi-bell-check";
    },
    showSnackbarDeleteSuccess(text) {
      this.snackbar = true;
      this.textSnackbar = text;
      this.colorSnackbar = "error";
      this.iconSnackbar = "mdi-bell-check";
    },
    showSnackbarErrorDialog(text) {
      this.snackbarError = true;
      this.textSnackbar = text;
      this.colorSnackbar = "error";
      this.iconSnackbar = "mdi-bell-remove";
    },
    showSnackbarError(text) {
      this.snackbar = true;
      this.textSnackbar = text;
      this.colorSnackbar = "error";
      this.iconSnackbar = "mdi-bell-remove";
    },
  },
};
</script>
<style scoped>
span {
  font-size: 15px;
  font-weight: 700;
}
small {
  font-size: 13px;
}
a {
  text-decoration: none !important;
}
</style>
